import { takeLatest, all } from 'redux-saga/effects';
import themes from 'devextreme/ui/themes';
import { ThemeAction, ThemeActionPayload } from './actions';

function* toggleTheme(themeName: {
  payload: ThemeActionPayload;
  type: ThemeAction;
}) {
  const { payload } = themeName;

  if (payload === window.localStorage.getItem('dx-theme')) return;

  window.localStorage.setItem('dx-theme', payload);
  yield themes.current(payload);
}

function* watchThemes() {
  yield takeLatest(ThemeAction.SET_THEME_DARK, toggleTheme);
  yield takeLatest(ThemeAction.SET_THEME_DARK_COMPACT, toggleTheme);
  yield takeLatest(ThemeAction.SET_THEME_LIGHT, toggleTheme);
  yield takeLatest(ThemeAction.SET_THEME_LIGHT_COMPACT, toggleTheme);
}

export default function* rootSaga() {
  yield all([watchThemes()]);
}
